import { Navigate, useSearchParams } from "react-router-dom";

export function LegacyCompanyRedirect({ section }: { section: "users" | "features" | "workflows" }) {
  const [params] = useSearchParams();
  const id = params.get("companyId");
  return <Navigate replace to={id && /^[0-9a-f-]{36}$/i.test(id) ? `/platform/companies/${id}/${section}` : "/platform/companies"} />;
}